import React from 'react' 
import styled from 'styled-components'
import AboutMe from './components/About'
import Contact from './components/Contact'
import Experiences from './components/Experiences'
import Footer from './components/Footer'
import Nav from './components/Nav'
import {SmallTitle, IntroText} from './components/styled'
import Technologies from './components/Technologies'
import Fade from 'react-reveal/Fade'

const HomePage = () => {
    return (
        <Container className="has-text-white">
            <Nav />
            
            <Hero className="hero ">
                <div className="hero-body">
                    <div className="container-fluid">
                        <SmallTitle>Hello... I am </SmallTitle>
                        <Name>Shadrack Mwangi</Name>
                        <NameSubtitle>A full stack software engineer</NameSubtitle>

                        <div className="content">
                            <IntroText>
                                I write code to help companies and users solve their everyday challenges, at the same time 
                                increase my competence. I build for web and desktop, and I'm currently learning how to 
                                build for mobile apps.
                            </IntroText>
                        </div>
                        <Btn className="button is-outlined">Contact me</Btn>
                        
                    </div>
                </div>
            </Hero>
            
            {/* About me */}
            <Fade left>
                <AboutMe />
            </Fade>
            {/* Technologies */}
            <Fade right>
                <Technologies />
            </Fade>

            {/* Experiences */}
            <Fade left >
                <Experiences />
            </Fade>

            {/* Contact */}
            <Fade right>
                <Contact />
            </Fade>

            {/* Footer */}
            <Footer />
        </Container>
    )
}


const Container = styled.div `
    height: 100%;
    margin-top: 1rem;
`



const Name = styled.h2 `
    font-size: 2rem;
    color: #ffffffe0;
    letter-spacing: 0.3rem;
    font-weight: 600;
    font-family: 'Poppins' sans-serif;
    line-height: 3rem;

    @media (min-width: 480px){
        font-size: 3rem;
        line-height: 5rem;
    }
`;

const NameSubtitle = styled.p `
    font-size: 1.4rem;
    color: #a7a2a2;
    text-transform: uppercase;
    font-weight: 600;
    font-family: 'Poppins', sans-serif;

    @media (min-width: 480px){
        font-size: 2rem;
    }
`

const Hero = styled.div `
    @media (min-width: 480px){
        position: relative;
        margin-top: 15rem;
    }

    width: 100%;
    margin-top: 3rem;
    
`



const Btn = styled.button `
    background-color: transparent;
    color: #da6c36;
    border-color: #da6c36;
    cursor: pointer;
    font-size: 1.2rem;
    font-weight: 500;

    &:hover {
        background-color: #da6c362e;
        color: #da6c36;
        border-color: #da6c36;
    }
`

export default HomePage;